(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(header) {
    if (header.dataset.navigationInitialized === 'true' || !window.AbortController) return;
    const trigger = header.querySelector('[data-nav-open]');
    const panel = header.querySelector('[data-nav-panel]');
    const backdrop = header.querySelector('[data-nav-backdrop]');
    const closeButton = header.querySelector('[data-nav-close]');
    if (!trigger || !panel || !backdrop || !closeButton) return;
    const mobile = window.matchMedia('(max-width: 720px)');
    const navigationEvents = new AbortController();
    let opened = false;

    const close = function (restoreFocus) {
      opened = false;
      trigger.setAttribute('aria-expanded', 'false');
      backdrop.hidden = true;
      panel.hidden = mobile.matches;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      document.documentElement.classList.remove('kss-menu-open');
      if (restoreFocus && mobile.matches) trigger.focus({ preventScroll: true });
    };
    const open = function () {
      if (!mobile.matches) return;
      opened = true;
      panel.hidden = false;
      backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      document.documentElement.classList.add('kss-menu-open');
      document.dispatchEvent(new CustomEvent('kss:overlay-open', { detail: { type: 'navigation' } }));
      closeButton.focus({ preventScroll: true });
    };
    const synchronize = function () {
      close(false);
      trigger.hidden = !mobile.matches;
      closeButton.hidden = !mobile.matches;
    };

    trigger.addEventListener('click', function () { if (opened) close(true); else open(); });
    closeButton.addEventListener('click', function () { close(true); });
    backdrop.addEventListener('click', function () { close(true); });
    panel.addEventListener('click', function (event) { if (event.target.closest('a')) close(false); });
    document.addEventListener('kss:overlay-open', function (event) { if (event.detail && event.detail.type !== 'navigation') close(false); }, { signal: navigationEvents.signal });
    document.addEventListener('keydown', function (event) {
      if (!opened) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (event.key === 'Tab') {
        const focusable = Array.from(panel.querySelectorAll('a, button, summary, input, select, [tabindex="0"]')).filter(function (node) { return !node.disabled && node.getClientRects().length; });
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); panel.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    }, { signal: navigationEvents.signal });
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(header)) return;
      close(false);
      navigationEvents.abort();
      if (mobile.removeEventListener) mobile.removeEventListener('change', synchronize);
      else if (mobile.removeListener) mobile.removeListener(synchronize);
    }, { signal: navigationEvents.signal });
    if (mobile.addEventListener) mobile.addEventListener('change', synchronize);
    else if (mobile.addListener) mobile.addListener(synchronize);
    header.dataset.navigationInitialized = 'true';
    header.classList.add('kss-nav-ready');
    synchronize();
  }
  const initializeWithin = function (root) {
    if (root.matches && root.matches('[data-kss-header]')) initialize(root);
    root.querySelectorAll('[data-kss-header]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function initialize(section) {
    if (section.dataset.cartInitialized === 'true') return;
    const configNode = section.querySelector('[data-cart-config]');
    if (!configNode || !window.fetch || !window.DOMParser) return;
    let strings;
    try { strings = JSON.parse(configNode.textContent); } catch (error) { return; }

    const readCart = function (root) {
      const state = root.querySelector('[data-cart-state]');
      if (!state) throw new Error(strings.update_error);
      return {
        item_count: Number(state.dataset.itemCount) || 0,
        items: Array.from(state.querySelectorAll('[data-cart-state-item]')).map(function (node) {
          return { key: node.dataset.key, variant_id: node.dataset.variantId, quantity: Number(node.dataset.quantity), properties: JSON.parse(node.dataset.properties || '{}'), selling_plan_id: node.dataset.sellingPlan || '' };
        })
      };
    };
    let cart;
    try { cart = readCart(section); } catch (error) { return; }
    const signature = function (item) {
      const properties = Object.entries(item.properties || {}).sort(function (a, b) { return a[0].localeCompare(b[0]); });
      const plan = item.selling_plan_id || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || '';
      return JSON.stringify([String(item.variant_id || item.id), properties, String(plan)]);
    };
    const resolveItem = function (entry) {
      const exact = cart.items.find(function (item) { return item.key === entry.key; });
      if (exact) return exact;
      const matches = cart.items.filter(function (item) { return signature(item) === entry.signature; });
      if (matches.length > 1) throw new Error(strings.reload_message);
      return matches[0] || null;
    };
    const pending = new Map();
    const invalid = new Map();
    let processing = false;
    let rendering = false;
    let inFlight = null;
    let needsReload = false;
    let timer = null;
    const sectionId = section.dataset.cartSection;
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    const setMessage = function (message, error) {
      const status = section.querySelector('[data-cart-status]');
      if (status) { status.textContent = message; status.dataset.error = error ? 'true' : 'false'; }
    };
    const synchronize = function () {
      const busy = processing || pending.size > 0;
      section.setAttribute('aria-busy', busy ? 'true' : 'false');
      section.querySelectorAll('[name="checkout"], [data-cart-update]').forEach(function (node) { node.disabled = busy || needsReload || invalid.size > 0; });
      section.querySelectorAll('[data-cart-quantity]').forEach(function (node) { node.disabled = needsReload; });
      section.querySelectorAll('[data-cart-remove]').forEach(function (node) {
        node.setAttribute('aria-disabled', needsReload ? 'true' : 'false');
        node.tabIndex = needsReload ? -1 : 0;
      });
      const reload = section.querySelector('[data-cart-reload]');
      if (reload) reload.hidden = !needsReload;
    };
    const focusState = function () {
      const node = document.activeElement;
      if (!node || !section.contains(node)) return null;
      if (node.matches('[name="note"]')) return { type: 'note', start: node.selectionStart, end: node.selectionEnd };
      if (node.matches('[data-cart-quantity]')) {
        const item = cart.items.find(function (item) { return item.key === node.dataset.lineKey; });
        if (item) return { type: 'quantity', key: item.key, signature: signature(item) };
      }
      return null;
    };
    const render = function (html) {
      if (typeof html !== 'string') throw new Error(strings.update_error);
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const fresh = documentFragment.querySelector('[data-cart-section]');
      if (!fresh) throw new Error(strings.update_error);
      const freshCart = readCart(fresh);
      const note = section.querySelector('[name="note"]');
      const draft = note ? note.value : '';
      const focus = focusState();
      rendering = true;
      try { section.innerHTML = fresh.innerHTML; } finally { rendering = false; }
      cart = freshCart;
      const newNote = section.querySelector('[name="note"]');
      if (newNote) newNote.value = draft;

      const applyDraft = function (entry, value, isInvalid) {
        const item = resolveItem(entry);
        if (!item) return;
        const input = Array.from(section.querySelectorAll('[data-cart-quantity]')).find(function (node) { return node.dataset.lineKey === item.key; });
        if (input) { input.value = String(value); input.setAttribute('aria-invalid', isInvalid ? 'true' : 'false'); }
      };
      pending.forEach(function (entry) { applyDraft(entry, entry.quantity, false); });
      invalid.forEach(function (entry) { applyDraft(entry, entry.value, true); });
      synchronize();
      if (focus) {
        const item = focus.type === 'quantity' ? resolveItem(focus) : null;
        const target = focus.type === 'note' ? newNote : (item && Array.from(section.querySelectorAll('[data-cart-quantity]')).find(function (node) { return node.dataset.lineKey === item.key; }));
        if (target && !target.disabled) {
          target.focus({ preventScroll: true });
          if (focus.type === 'note' && typeof focus.start === 'number') target.setSelectionRange(focus.start, focus.end);
        }
      }
      document.querySelectorAll('[data-cart-count], [data-header-cart-count]').forEach(function (node) { node.textContent = String(cart.item_count); node.hidden = cart.item_count < 1; });
    };
    const request = async function (url, options) {
      const controller = new AbortController();
      const timeout = window.setTimeout(function () { controller.abort(); }, 10000);
      try {
        const response = await fetch(url, Object.assign({}, options, { signal: controller.signal }));
        const data = await response.json().catch(function () { return null; });
        if (!response.ok || !data) throw new Error(data && typeof data.description === 'string' ? data.description : strings.update_error);
        return data;
      } finally { window.clearTimeout(timeout); }
    };
    const refresh = async function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', sectionId);
      const sections = await request(url.toString(), { headers: { Accept: 'application/json' } });
      render(sections[sectionId]);
    };
    const flush = async function () {
      window.clearTimeout(timer);
      if (processing || needsReload || !pending.size) return;
      processing = true;
      synchronize();
      setMessage(strings.updating, false);
      try {
        while (pending.size) {
          const key = pending.keys().next().value;
          const entry = pending.get(key);
          pending.delete(key);
          const item = resolveItem(entry);
          if (!item) continue;
          inFlight = entry;
          const data = await request(root + 'cart/change.js', {
            method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: entry.quantity, sections: [sectionId], sections_url: window.location.pathname })
          });
          const html = data.sections && data.sections[sectionId];
          if (typeof html === 'string') render(html);
          else await refresh();
          inFlight = null;
          document.dispatchEvent(new CustomEvent('kss:cart-updated', { detail: data }));
          setMessage(strings.updating, false);
        }
        setMessage(invalid.size ? strings.quantity_error : strings.updated, invalid.size > 0);
      } catch (error) {
        pending.clear();
        invalid.clear();
        try {
          await refresh();
          setMessage(error.message || strings.update_error, true);
        } catch (refreshError) {
          needsReload = true;
          setMessage(strings.reload_message, true);
        }
      } finally {
        inFlight = null;
        processing = false;
        synchronize();
        if (pending.size && !needsReload) void flush();
      }
    };
    const queue = function (input, immediate) {
      if (needsReload || rendering) return;
      const item = cart.items.find(function (item) { return item.key === input.dataset.lineKey; });
      if (!item) return;
      const entry = { key: item.key, signature: signature(item), quantity: Number(input.value) };
      const uniqueIdentity = cart.items.filter(function (candidate) { return signature(candidate) === entry.signature; }).length === 1;
      [pending, invalid].forEach(function (drafts) {
        drafts.forEach(function (draft, key) { if (key === item.key || (uniqueIdentity && draft.signature === entry.signature)) drafts.delete(key); });
      });
      if (input.value.trim() === '' || !Number.isInteger(entry.quantity) || entry.quantity < 0) {
        pending.delete(item.key);
        invalid.set(item.key, Object.assign(entry, { value: input.value }));
        input.setAttribute('aria-invalid', 'true');
        setMessage(strings.quantity_error, true);
        synchronize();
        return;
      }
      invalid.delete(item.key);
      input.setAttribute('aria-invalid', 'false');
      const sameRequest = inFlight && (inFlight.key === item.key || (uniqueIdentity && inFlight.signature === entry.signature));
      if ((sameRequest && inFlight.quantity === entry.quantity) || (!sameRequest && item.quantity === entry.quantity)) {
        synchronize();
        if (!processing && !pending.size) setMessage(invalid.size ? strings.quantity_error : strings.updated, invalid.size > 0);
        return;
      }
      pending.set(item.key, entry);
      synchronize();
      setMessage(strings.updating, false);
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { void flush(); }, immediate ? 0 : 350);
    };

    section.addEventListener('input', function (event) { if (event.target.matches('[data-cart-quantity]')) queue(event.target, false); });
    section.addEventListener('change', function (event) { if (event.target.matches('[data-cart-quantity]')) queue(event.target, true); });
    section.addEventListener('click', function (event) {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      if (needsReload) return;
      const input = Array.from(section.querySelectorAll('[data-cart-quantity]')).find(function (node) { return node.dataset.lineKey === remove.dataset.lineKey; });
      if (input) { input.value = '0'; queue(input, true); }
    });
    section.addEventListener('submit', function (event) {
      if (event.target.matches('form') && (processing || pending.size || invalid.size || needsReload)) {
        event.preventDefault();
        if (!needsReload && !invalid.size) void flush();
      }
    });
    section.dataset.cartInitialized = 'true';
    synchronize();
  }
  const initializeWithin = function (root) {
    if (root.matches && root.matches('[data-cart-section]')) initialize(root);
    root.querySelectorAll('[data-cart-section]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(section) {
    if (section.dataset.productInitialized === 'true') return;

    const form = section.querySelector('[data-product-form]');
    const variantData = section.querySelector('[data-product-variants]');
    const configData = section.querySelector('[data-product-config]');
    const idInput = section.querySelector('[data-variant-id]');
    if (!form || !variantData || !configData || !idInput) return;

    let variants;
    let config;
    try {
      variants = JSON.parse(variantData.textContent);
      config = JSON.parse(configData.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length || !config.strings) return;
    section.dataset.productInitialized = 'true';

    const strings = config.strings;
    const selects = Array.from(form.querySelectorAll('select[name^="options"]'));
    const button = form.querySelector('[data-add-to-cart]');
    const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    const priceNode = section.querySelector('[data-price]');
    const compareNode = section.querySelector('[data-compare-price]');
    const availabilityNode = section.querySelector('[data-product-availability]');
    const variantMessage = section.querySelector('[data-variant-message]');
    const gallery = section.querySelector('[data-product-gallery]');
    let syncSticky = function () {};
    const initialId = String(idInput.value);
    let currentVariant = null;
    let isSubmitting = false;
    let showMedia = function () {};

    if (gallery) {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const status = gallery.querySelector('[data-gallery-status]');
      const mobileQuery = window.matchMedia('(max-width: 640px)');
      let index = 0;

      const dialog = section.querySelector('[data-gallery-dialog]');
      const zoomImage = dialog && dialog.querySelector('[data-zoom-image]');
      const zoomStatus = dialog && dialog.querySelector('[data-zoom-status]');
      let ignoredClickUntil = 0;
      const syncZoom = function () {
        if (!dialog || !dialog.open || !zoomImage) return;
        const link = slides[index] && slides[index].querySelector('[data-gallery-zoom]');
        const image = link && link.querySelector('img');
        if (link) { zoomImage.src = link.href; zoomImage.alt = image ? image.alt : ''; }
        if (zoomStatus) zoomStatus.textContent = strings.gallery_status.replace('__INDEX__', String(index + 1)).replace('__TOTAL__', String(slides.length));
      };
      if (dialog && typeof dialog.showModal === 'function') {
        gallery.addEventListener('click', function (event) {
          const link = event.target.closest('[data-gallery-zoom]');
          if (!link) return;
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (Date.now() < ignoredClickUntil) return;
          document.dispatchEvent(new CustomEvent('kss:overlay-open', { detail: { type: 'gallery' } }));
          dialog.showModal();
          document.documentElement.classList.add('kss-gallery-zoom-open');
          syncZoom();
        });
        dialog.querySelector('[data-zoom-close]').addEventListener('click', function () { dialog.close(); });
        const zoomPrevious = dialog.querySelector('[data-zoom-prev]');
        const zoomNext = dialog.querySelector('[data-zoom-next]');
        if (zoomPrevious) zoomPrevious.addEventListener('click', function () { show(index - 1); });
        if (zoomNext) zoomNext.addEventListener('click', function () { show(index + 1); });
        dialog.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
        });
        dialog.addEventListener('click', function (event) { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
        dialog.addEventListener('close', function () {
          document.documentElement.classList.remove('kss-gallery-zoom-open');
          const link = slides[index] && slides[index].querySelector('[data-gallery-zoom]');
          if (link) link.focus({ preventScroll: true });
        });
      }
      const mainImage = gallery.querySelector('.product-gallery-main');
      let gesture = null;
      if (mainImage && window.PointerEvent) {
        mainImage.addEventListener('pointerdown', function (event) {
          gesture = event.isPrimary && event.pointerType !== 'mouse' ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
        }, { passive: true });
        mainImage.addEventListener('pointercancel', function () { gesture = null; }, { passive: true });
        mainImage.addEventListener('pointerup', function (event) {
          if (!gesture || gesture.id !== event.pointerId) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          gesture = null;
          if (slides.length > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            ignoredClickUntil = Date.now() + 400;
            show(index + (dx < 0 ? 1 : -1));
          }
        }, { passive: true });
      }

      const show = function (requestedIndex) {
        if (!slides.length) return;
        index = (requestedIndex + slides.length) % slides.length;
        const requestedLimit = Number(mobileQuery.matches ? section.dataset.galleryMobileLimit : section.dataset.galleryLimit);
        const limit = Math.max(1, Math.min(thumbs.length || 1, requestedLimit || (mobileQuery.matches ? 5 : 7)));
        const start = Math.max(0, Math.min(index - Math.floor(limit / 2), thumbs.length - limit));

        slides.forEach(function (slide, position) {
          const active = position === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach(function (thumb, position) {
          const active = position === index;
          thumb.disabled = false;
          thumb.classList.toggle('is-active', active);
          thumb.classList.toggle('is-gallery-hidden', position < start || position >= start + limit);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (status) status.textContent = strings.gallery_status.replace('__INDEX__', String(index + 1)).replace('__TOTAL__', String(slides.length));
        syncZoom();
      };

      thumbs.forEach(function (thumb, position) {
        thumb.addEventListener('click', function () { show(position); });
      });
      if (previous) {
        previous.disabled = slides.length < 2;
        previous.addEventListener('click', function () { show(index - 1); });
      }
      if (next) {
        next.disabled = slides.length < 2;
        next.addEventListener('click', function () { show(index + 1); });
      }
      gallery.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      const refreshGallery = function () { show(index); };
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', refreshGallery);
      else if (mobileQuery.addListener) mobileQuery.addListener(refreshGallery);

      showMedia = function (variant, selectedValues) {
        const featuredId = variant && ((variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id));
        let featuredIndex = featuredId ? slides.findIndex(function (slide) { return String(slide.dataset.mediaId) === String(featuredId); }) : -1;
        if (featuredIndex < 0 && selectedValues.length) {
          const values = selectedValues.map(function (value) { return String(value).trim().toLowerCase(); }).filter(function (value) { return value.length > 1; });
          featuredIndex = slides.findIndex(function (slide) {
            const alt = String(slide.dataset.galleryAlt || '').toLowerCase();
            return values.some(function (value) { return alt.includes(value); });
          });
        }
        show(featuredIndex >= 0 ? featuredIndex : index);
      };
      show(0);
    }

    const fallbackPrice = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: config.currency }).format(Number(cents) / 100);
      } catch (error) {
        return config.currency + ' ' + (Number(cents) / 100).toFixed(2);
      }
    };

    const syncPurchaseState = function () {
      const available = Boolean(currentVariant && currentVariant.available);
      idInput.disabled = !available;
      form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      if (button) {
        button.disabled = isSubmitting || !available;
        button.textContent = isSubmitting ? strings.adding : (!currentVariant ? strings.unavailable : (available ? strings.add_to_cart : strings.sold_out));
      }
      syncSticky();
      if (dynamicCheckout) {
        dynamicCheckout.hidden = !available;
        dynamicCheckout.inert = isSubmitting || !available;
        dynamicCheckout.setAttribute('aria-disabled', isSubmitting || !available ? 'true' : 'false');
      }
    };

    const updateVariant = function () {
      const selected = selects.map(function (select) { return select.value; });
      const match = selects.length
        ? variants.find(function (variant) { return Array.isArray(variant.options) && variant.options.length === selected.length && variant.options.every(function (value, position) { return value === selected[position]; }); })
        : (variants.find(function (variant) { return String(variant.id) === initialId; }) || variants[0]);
      const oldId = idInput.value;
      currentVariant = match || null;
      idInput.value = match ? String(match.id) : '';

      if (variantMessage) {
        variantMessage.hidden = Boolean(match);
        variantMessage.textContent = match ? '' : strings.unavailable_message;
      }
      if (availabilityNode) availabilityNode.textContent = !match ? strings.unavailable : (match.available ? strings.in_stock : strings.currently_sold_out);
      if (priceNode) {
        const formatted = match && config.prices[String(match.id)];
        priceNode.textContent = match ? ((formatted && formatted.price) || fallbackPrice(match.price)) : strings.unavailable;
      }
      if (compareNode) {
        const showCompare = Boolean(match && Number(match.compare_at_price) > Number(match.price));
        const formatted = match && config.prices[String(match.id)];
        compareNode.hidden = !showCompare;
        compareNode.textContent = showCompare ? ((formatted && formatted.compare_price) || fallbackPrice(match.compare_at_price)) : '';
      }
      syncPurchaseState();
      if (oldId !== idInput.value) idInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        if (match) url.searchParams.set('variant', String(match.id));
        else url.searchParams.delete('variant');
        try { window.history.replaceState(window.history.state, '', url.toString()); } catch (error) {}
      }
      if (match) showMedia(match, selected);
    };

    selects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
      select.disabled = false;
    });
    updateVariant();

    const sticky = section.querySelector('[data-sticky-purchase]');
    const stickyButton = sticky && sticky.querySelector('[data-sticky-add]');
    const stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
    if (sticky && stickyButton && button) {
      syncSticky = function () { stickyButton.disabled = button.disabled; stickyButton.textContent = button.textContent; if (stickyPrice && priceNode) stickyPrice.textContent = priceNode.textContent; };
      syncSticky();
      const mobilePurchase = window.matchMedia('(max-width: 720px)');
      let frame = null;
      const updateSticky = function () {
        frame = null;
        const active = document.activeElement;
        const editing = active && active.matches('input:not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]');
        const viewport = window.visualViewport;
        const keyboardOpen = viewport && viewport.height < window.innerHeight * 0.75;
        const visible = section.isConnected && mobilePurchase.matches && !editing && !keyboardOpen && button.getBoundingClientRect().bottom < 0;
        sticky.hidden = !visible;
        document.documentElement.classList.toggle('kss-sticky-purchase-visible', Boolean(visible));
        if (visible) document.documentElement.style.setProperty('--kss-purchase-height', Math.ceil(sticky.getBoundingClientRect().height || 80) + 'px');
      };
      const scheduleSticky = function () { if (frame === null) frame = window.requestAnimationFrame(updateSticky); };
      stickyButton.addEventListener('click', function () { if (!button.disabled) { if (form.requestSubmit) form.requestSubmit(button); else button.click(); } });
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky, { passive: true });
      document.addEventListener('focusin', scheduleSticky);
      document.addEventListener('focusout', scheduleSticky);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleSticky);
      const observer = window.IntersectionObserver ? new IntersectionObserver(scheduleSticky) : null;
      if (observer) observer.observe(button);
      const resizeObserver = window.ResizeObserver ? new ResizeObserver(scheduleSticky) : null;
      if (resizeObserver) resizeObserver.observe(sticky);
      const unload = function (event) {
        if (event.target !== section && !event.target.contains(section)) return;
        window.removeEventListener('scroll', scheduleSticky);
        window.removeEventListener('resize', scheduleSticky);
        document.removeEventListener('focusin', scheduleSticky);
        document.removeEventListener('focusout', scheduleSticky);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', scheduleSticky);
        if (observer) observer.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        if (frame !== null) window.cancelAnimationFrame(frame);
        document.documentElement.classList.remove('kss-sticky-purchase-visible', 'kss-gallery-zoom-open', 'kss-cart-feedback-open');
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      scheduleSticky();
    }

    const toast = section.querySelector('[data-cart-toast]');
    const toastTitle = section.querySelector('[data-cart-toast-title]');
    const toastText = section.querySelector('[data-cart-toast-text]');
    const toastEyebrow = section.querySelector('[data-cart-toast-eyebrow]');
    const toastCheckout = section.querySelector('[data-cart-toast-checkout]');
    const toastClose = section.querySelector('[data-cart-toast-close]');
    let toastTimer = null;

    const hideToast = function () {
      window.clearTimeout(toastTimer);
      document.documentElement.classList.remove('kss-cart-feedback-open');
      if (!toast) return;
      const hadFocus = toast.contains(document.activeElement);
      toast.classList.remove('is-visible');
      toast.hidden = true;
      if (hadFocus && button && !button.disabled) button.focus({ preventScroll: true });
    };
    const scheduleToastClose = function () {
      window.clearTimeout(toastTimer);
      if (!toast || toast.dataset.state !== 'success') return;
      toastTimer = window.setTimeout(function () {
        if (!toast.contains(document.activeElement)) hideToast();
      }, 6000);
    };
    const showToast = function (state, title, message) {
      window.clearTimeout(toastTimer);
      if (!toast) return;
      document.documentElement.classList.add('kss-cart-feedback-open');
      toast.dataset.state = state;
      toast.setAttribute('role', state === 'success' ? 'status' : 'alert');
      toast.setAttribute('aria-live', state === 'success' ? 'polite' : 'assertive');
      if (toastTitle) toastTitle.textContent = title;
      if (toastText) toastText.textContent = message;
      if (toastEyebrow) toastEyebrow.textContent = state === 'success' ? strings.cart_updated : strings.cart_attention;
      if (toastCheckout) toastCheckout.hidden = state !== 'success';
      toast.hidden = false;
      window.requestAnimationFrame(function () {
        if (!toast.hidden) toast.classList.add('is-visible');
      });
      scheduleToastClose();
    };
    if (toastClose) toastClose.addEventListener('click', hideToast);
    if (toast) {
      toast.addEventListener('focusin', function () { window.clearTimeout(toastTimer); });
      toast.addEventListener('focusout', scheduleToastClose);
    }

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    let countRequest = 0;
    const updateCartCount = async function () {
      const request = ++countRequest;
      const controller = new AbortController();
      const timer = window.setTimeout(function () { controller.abort(); }, 8000);
      try {
        const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (request !== countRequest) return;
        const count = Number(cart.item_count) || 0;
        document.querySelectorAll('[data-cart-count], .cart-count, [data-header-cart-count]').forEach(function (node) {
          node.textContent = String(count);
          node.hidden = count < 1;
        });
        document.dispatchEvent(new CustomEvent('kss:cart-updated', { detail: cart }));
      } catch (error) {
      } finally {
        window.clearTimeout(timer);
      }
    };

    form.addEventListener('submit', async function (event) {
      if (!currentVariant || !currentVariant.available || isSubmitting) {
        event.preventDefault();
        return;
      }
      const submitter = event.submitter;
      if (submitter && !submitter.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      if (!form.reportValidity()) return;
      const formData = new FormData(form);
      const quantity = Number(formData.get('quantity'));
      if (!Number.isInteger(quantity) || quantity < 1) {
        showToast('error', strings.error_title, strings.invalid_quantity);
        return;
      }

      isSubmitting = true;
      hideToast();
      syncPurchaseState();
      const controller = new AbortController();
      const timer = window.setTimeout(function () { controller.abort(); }, 15000);
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData, signal: controller.signal });
        const data = await response.json().catch(function () { return null; });
        if (!response.ok) {
          const description = data && typeof data.description === 'string' ? data.description : strings.error_message;
          showToast('error', strings.error_title, description);
          return;
        }
        if (!data || typeof data !== 'object') {
          showToast('error', strings.uncertain_title, strings.uncertain_message);
          void updateCartCount();
          return;
        }
        const title = data.product_title || data.title;
        showToast('success', strings.added_title, title ? strings.added_item.replace('__TITLE__', String(title)) : strings.added_message);
        void updateCartCount();
      } catch (error) {
        showToast('error', strings.uncertain_title, strings.uncertain_message);
      } finally {
        window.clearTimeout(timer);
        isSubmitting = false;
        syncPurchaseState();
      }
    });
  }

  const initializeWithin = function (root) {
    if (root.matches && root.matches('[data-product-section]')) initialize(root);
    root.querySelectorAll('[data-product-section]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
})();
  
  } catch(e) { console.error(e); }
})();
})();
